import { createRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

import type { FilterDrawerFormValue } from '@/components/shared/filter-drawer/types';

import { dashboardLayoutComponent } from '../layouts/dashboard-layout-route';

export const disbursementRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/disbursement',
  component: lazyRouteComponent(() => import('@/pages/disbursement/disbursement-page')),
  beforeLoad: ({ location }) => {
    if (location.pathname === '/disbursement') {
      throw redirect({ to: '/disbursement/single' });
    }
  },
});

export const disbursementSingleRoute = createRoute({
  getParentRoute: () => disbursementRoute,
  path: 'single',
  component: lazyRouteComponent(() => import('@/pages/disbursement/disbursement-single-page')),
  validateSearch: (search: Record<string, unknown>): FilterDrawerFormValue => {
    return { ...search };
  },
});

export const disbursementBatchRoute = createRoute({
  getParentRoute: () => disbursementRoute,
  path: 'batch',
  component: lazyRouteComponent(() => import('@/pages/disbursement/disbursement-batch-page')),
  validateSearch: (search: Record<string, unknown>): FilterDrawerFormValue => {
    return { ...search };
  },
});

export const detailDisbursementRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/disbursement/$id',
  component: lazyRouteComponent(
    () => import('@/pages/disbursement/disbursement-single-detail-page'),
  ),
});

export const detailBatchDisbursementRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/disbursement/batch/$id',
  component: lazyRouteComponent(
    () => import('@/pages/disbursement/disbursement-batch-detail-page'),
  ),
  validateSearch: (search: Record<string, unknown>): FilterDrawerFormValue => {
    return { ...search };
  },
});
